import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function Footer() {
  const { categories } = useApp();
  return (
    <footer className="mt-16 border-t" style={{ borderColor: "var(--amd-border)", background: "#000" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded flex items-center justify-center font-black text-white text-xs" style={{ background: "var(--amd-primary)" }}>64</div>
            <span className="text-white font-black text-lg">amd<span style={{ color: "var(--amd-primary)" }}>64</span>.ro</span>
          </div>
          <p style={{ color: "var(--amd-text-muted)" }}>
            Marketplace-ul românesc pentru anunțuri de vânzare-cumpărare. Simplu, rapid, sigur.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Categorii</h4>
          <ul className="space-y-2">
            {categories.slice(0, 6).map((c) => (
              <li key={c.id}>
                <Link to={`/categorie/${c.id}`} className="amd-link" style={{ color: "var(--amd-text-muted)" }}>{c.name}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Informații</h4>
          <ul className="space-y-2" style={{ color: "var(--amd-text-muted)" }}>
            <li><Link to="/" className="amd-link">Despre noi</Link></li>
            <li><Link to="/" className="amd-link">Termeni și condiții</Link></li>
            <li><Link to="/" className="amd-link">Politica de confidențialitate</Link></li>
            <li><Link to="/" className="amd-link">Cookie-uri</Link></li>
            <li><Link to="/" className="amd-link">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Pentru utilizatori</h4>
          <ul className="space-y-2" style={{ color: "var(--amd-text-muted)" }}>
            <li><Link to="/adauga-anunt" className="amd-link">Postează anunț</Link></li>
            <li><Link to="/favorite" className="amd-link">Anunțurile mele favorite</Link></li>
            <li><Link to="/admin/login" className="amd-link">Acces administrare</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t py-5" style={{ borderColor: "var(--amd-border)" }}>
        <div className="max-w-7xl mx-auto px-4 md:px-6 text-xs flex flex-col md:flex-row items-center justify-between gap-2" style={{ color: "var(--amd-text-muted)" }}>
          <span>© {new Date().getFullYear()} amd64.ro — Toate drepturile rezervate.</span>
          <span>Construit în România</span>
        </div>
      </div>
    </footer>
  );
}
